import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  getComparator,
} from "../../../../../component/Methods";

const formatDirection = (direction) => {
  if (!direction || typeof direction !== "string") return "";
  return direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();
};

const Blacklisted = ({ rows = [], tableHeader = [] }) => {
  const theme = useTheme();
  const safeRows = useMemo(
    () => (Array.isArray(rows) ? rows.filter(Boolean) : []),
    [rows]
  );
  const [data, setData] = useState(safeRows);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("ticker");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    try {
      const filteredData = applySortFilter(
        safeRows,
        getComparator(order, orderBy)
      );
      setData(Array.isArray(filteredData) ? filteredData : safeRows);
    } catch {
      setData(safeRows);
    }
  }, [order, orderBy, safeRows]);

  return (
    <Box
      sx={{
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        width: "100%",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <TableContainer
        sx={{
          flex: "1 1 0px",
          minHeight: 0,
          height: 0,
          maxHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "block",
        }}
      >
        <Table size="small" stickyHeader aria-label="a dense table">
          <VantageListHead
            order={order}
            orderBy={orderBy}
            headLabel={tableHeader}
            noStatus={true}
            customizeFont={12}
            rowCount={data?.length || 0}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {(Array.isArray(data) ? data : []).map((row, index) => {
              const tickerLabel =
                typeof row?.ticker === "string"
                  ? row.ticker.toUpperCase()
                  : row?.ticker?.symbol
                    ? String(row.ticker.symbol).toUpperCase()
                    : "";
              const rowKey = [
                row?.fund,
                row?.strategy,
                tickerLabel,
                row?.direction,
                index,
              ]
                .filter(Boolean)
                .join("-");

              return (
                <TableRow
                  key={rowKey || index}
                  sx={{
                    backgroundColor: theme.palette.background.paper,
                    "&:hover": {
                      background: theme.palette.action.hover,
                      cursor: "pointer",
                      borderColor: theme.palette.divider,
                    },
                  }}
                >
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.fund || ""}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {row?.strategy || ""}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {tickerLabel}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "40%",
                    }}
                  >
                    {row?.reason || ""}
                  </Tablecell>
                  <Tablecell
                    align="left"
                    sx={{
                      fontSize: "12px",
                      paddingLeft: "10px",
                      borderLeft: "none",
                      borderRight: "none",
                      color: theme.palette.text.primary,
                      backgroundColor: theme.palette.background.paper,
                      borderColor: theme.palette.divider,
                      width: "20%",
                    }}
                  >
                    {formatDirection(row?.direction)}
                  </Tablecell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Blacklisted;
